import { settings } from './../settings';
import moment from 'moment';

class Tools {
    toWeekday(day) {
        return settings.resources.weekdays[parseInt(day)];
    }

    validateEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        return re.test(String(email).toLowerCase());
    }

    validatePhone(phone) {
        const match = phone.match(/^\d{7,13}$/);

        if (!match) {
            return false;
        }

        return true;
    }
    validateOtp(otp) {
        const match = otp.match(/^\d{6}$/);

        if (!match) {
            return false;
        }

        return true;
    }

    isChild(pnr) {
        const match = this.personalNumberToArray(pnr);

        if (!match) {
            return false;
        }

        const fullyear = match[0],
            month = match[1],
            day = match[2];

        if (!this.validateDate(+fullyear, +month, +day)) {
            return false;
        }

        const date = new Date(parseInt(fullyear) + settings.adultage, 0, 1);
        const child = date > new Date(new Date().getFullYear(), 0, 1);

        // if (child)
        //     console.log(`CHILD: ${pnr} :: ${fullyear} ${month} ${day}`);
        // else
        //     console.log(`ADULT: ${pnr} :: ${fullyear} ${month} ${day}`);

        return child;
    }

    personalNumberToArray(pnr) {
        const match = this.personalNumberToDates(pnr);

        if (!match) {
            return null;
        }

        let century = match[1],
            year = match[2],
            month = match[3],
            day = match[4],
            sep = match[5],
            num = match[6],
            check = match[7];

        if (sep === undefined) {
            sep = '-';
        }

        if (century === undefined) {
            century = sep == '-' ? 19 : 20;
        }

        const fullyear = `${century}${year}`;

        // if (day < 60)
        //     console.log(`PERSONNUMMER: ${pnr} :: ${fullyear} ${month} ${day} - ${num} ${check}`);
        // else
        //     console.log(`SAMORDNINGNR: ${pnr} :: ${fullyear} ${month} ${day} - ${num} ${check}`);

        return [fullyear, month, day, num, check];
    }

    personalNumberToDates(pnr) {
        if (typeof pnr !== 'number' && typeof pnr !== 'string') {
            return null;
        }

        pnr += '';

        const reg = /^(\d{2}){0,1}(\d{2})(\d{2})(\d{2})([-|+]{0,1})?(\d{3})(\d{0,1})$/;
        const match = reg.exec(pnr);

        if (!match) {
            return null;
        }

        return match;
    }

    validatePersonalNumber(pnr) {
        var match = this.personalNumberToArray(pnr);

        if (!match) {
            return false;
        }

        let valid = false;
        const fullyear = match[0],
            month = match[1],
            day = match[2],
            num = match[3],
            check = match[4];

        valid = this.validateLuhn(fullyear.substring(2, 4) + month + day + num) === +check && !!check;
        valid = valid && this.validateDate(+fullyear, +month, +day);

        if (!valid) {
            valid = valid && this.validateDate(+fullyear, +month, +day - 60);
        }

        //console.log(`VALID PERSONNUMMER: ${pnr} :: ${valid}`);

        return valid;
    }

    validateDate(year, month, day) {
        month -= 1;

        const date = new Date(year, month, day);

        return !(date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day);
    }

    validateLuhn(pnr) {
        let v = 0,
            sum = 0;

        pnr += '';

        for (var i = 0, l = pnr.length; i < l; i++) {
            v = pnr[i];
            v *= 2 - (i % 2);
            if (v > 9) {
                v -= 9;
            }
            sum += v;
        }

        return Math.ceil(sum / 10) * 10 - sum;
    }

    formatToTime(str) {
        const date = this.toDate(str);

        //console.log(str + ' ' + (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':' + (date.getMinutes() + '000').substr(0, 2));

        return (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':' + (date.getMinutes() + '000').substr(0, 2);
    }

    formatDateTimeForCalendar(str){
        return moment(str).format("YYYYMMDDTHHmmSSZ");
    }

    formatToDate(str) {
        const date = this.toDate(str);

        return date.getDate() + ' ' + date.toLocaleString(settings.language, { month: 'long' });
    }

    formatToISODate(date) {
        return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
    }

    formatToISODateAndTime(date) {
        return `${this.formatToISODate(date)} ${('0' + date.getHours()).slice(-2)}:${('0' + date.getMinutes()).slice(-2)}:${(
            '0' + date.getSeconds()
        ).slice(-2)}`;
    }

    isWithinNHours(str, hours) {
        const date = this.toDate(str),
            compare = new Date().getTime() + 1 * +hours * 60 * 60 * 1000;

        return compare > date;
    }

    isInPast(str) {
        const date = this.toDate(str),
            compare = new Date();

        return compare > date;
    }

    isTimeEqualLength(date1start, date1end, date2start, date2end) {
        const first = this.toDate(date1end) - this.toDate(date1start),
            second = this.toDate(date2end) - this.toDate(date2start);

        return first == second;
    }

    getDuration(start, end) {
        const diff = this.toDate(end) - this.toDate(start);

        return Math.floor(diff / 1000 / 60);
    }

    formatPhoneToLink(phone) {
        return phone.replace(/[^+\d]+/g, '');
    }

    formatToPrefix(str) {
        const date = this.toDate(str),
            today = new Date(),
            tomorrow = new Date();

        date.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        tomorrow.setHours(0, 0, 0, 0);
        tomorrow.setDate(tomorrow.getDate() + 1);

        if (date.toString() == today.toString()) return settings.resources.today;
        else if (date.toString() == tomorrow.toString()) return settings.resources.tomorrow;
        else return settings.resources.weekdays[date.getDay()];
    }

    formatToMonths(str) {
        const date = this.toDate(str);
        
        return settings.resources.months[date.getMonth()];
    }

    getDateOfMonth(str) {
        const date = this.toDate(str);
        
        return date.getDate();
    }

    findByValue(data, key, value) {
        for (let i = 0; i < data.length; i++) {
            if (data[i][key] === value) return data[i];
        }
        return null;
    }

    inArray(data, value, key) {
        for (let i = 0; i < data.length; i++) {
            if (key && data[i][key] === value) return true;
            else if (data[i] === value) return true;
        }

        return false;
    }

    toTitleCase(str) {
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }

    numberToSek(num) {
        return num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ':-' : '-';
    }

    addDaysToDate(days, date) {
        const result = date ? new Date(date.valueOf()) : new Date();
        result.setDate(result.getDate() + days);
        return result;
    }

    addDaysToNow(days) {
        const result = new Date();
        result.setDate(result.getDate() + days);
        return result;
    }

    addHoursToNow(hours) {
        return this.addHoursToDate(hours, new Date());
    }

    addHoursToDate(hours, date) {
        const result = date ? new Date(date.valueOf()) : new Date();
        result.setTime(result.getTime() + hours * 60 * 60 * 1000);
        return result;
    }

    addMinutesToDate(minutes, date) {
        const result = date ? new Date(date.valueOf()) : new Date();
        result.setTime(result.getTime() + minutes * 60 * 1000);
        return result;
    }

    toDate(str) {
        // Clear timezone info
        const nstr = str.replace('Z', '').replace('T', ' ').replace(/-/g, '/').replace(/\.\d+/, "");
        
        return new Date(nstr);
    }

    trackEcommerce(bookingId, timeSlot, treatment) {
        const transaction = {
            'id': bookingId,
            'affiliation': timeSlot.clinic.name,
            'revenue': timeSlot.price || timeSlot.discountedPrice,
            'shipping': '0',
            'tax': '0',
            'currency': 'SEK',
        };
        window.ga('ecommerce:addTransaction', transaction);
        const bookingItem = {
            'id': bookingId,
            'name': timeSlot.clinic.name + ' - ' + treatment.name + ' - ' + timeSlot.clinician.name + ', ' + timeSlot.clinician.title + (timeSlot.discountedPrice ? ' - Sista minuten' : ' - Ordinarie'),
            'sku': timeSlot.treatmentId + '',
            'category': treatment.name,
            'price': timeSlot.price || timeSlot.discountedPrice,
            'quantity': '1',
            'currency': 'SEK',
        };
        window.ga('ecommerce:addItem', bookingItem);
        window.ga('ecommerce:send');
    }

    trackFBPixelPurchase(bookingId, timeSlot, treatment) {
        const purchaseEventObject = {
            currency: 'SEK',
            value: timeSlot.price || timeSlot.discountedPrice || 0,
            content_name: timeSlot.clinic.name + ' - ' + treatment.name + ' - ' + timeSlot.clinician.name + ', ' + timeSlot.clinician.title + (timeSlot.discountedPrice ? ' - Sista minuten' : ' - Ordinarie'),
            content_ids: [bookingId],
            content_type: treatment.name,
            num_items: 1,
        }

        try {
            window.fbq('track', 'Purchase', purchaseEventObject);
        }
        catch (err) {
            setTimeout(function () { self.trackFBPixelPurchase(bookingId, timeSlot, treatment); }, 5000);
        }
    }

    trackFBPixelInitiateCheckout(reservationId, timeSlot, treatment) {
        const self = this;
        const purchaseEventObject = {
            currency: 'SEK',
            value: timeSlot.price || timeSlot.discountedPrice || 0,
            content_category: treatment.name,
            content_ids: [reservationId],
            num_items: 1,
        }
        try {
            window.fbq('track', 'InitiateCheckout', purchaseEventObject);
        }
        catch (err) {
            setTimeout(function () {
                self.trackFBPixelInitiateCheckout(reservationId, timeSlot, treatment);
            }, 5000);
        }
    }
     trackView(page, title, clinic, treatment, bookingtype, patientstatus, callback) {
        /*
        Dimensions
    
        1 Behandling
        2 Klinik
        3 Listning
        4 Bokning
        5 Bekräftelse
        6 BankID
        7 Tid vald
        */

        if (!window.ga) {
            // eslint-disable-next-line no-console
            console.error('Missing log framework');
        }

        const dimensions = {
            treatment: 'dimension1',
            clinic: 'dimension2',
            list: 'dimension3',
            booking: 'dimension4',
            confirm: 'dimension5',
            bankid: 'dimension6',
            time: 'dimension7',
            bookingtype: 'dimension8',
            patientstatus: 'dimension9',
        };

        const options = {
            hitType: 'pageview',
            page: location.pathname + '#' + page.trim(),
            title: document.title + ' - ' + title.trim(),
        };

        if (treatment) {
            options[dimensions.treatment] = treatment.name;
        }

        if (clinic) {
            options[dimensions.clinic] = clinic.name;
        }

        if (bookingtype) options[dimensions.bookingtype] = bookingtype;

        if (patientstatus) options[dimensions.patientstatus] = patientstatus;

        if (typeof callback === 'function') {
            callback(options);
        }

        window.ga('send', options);
    }

    trackConversion() {
        window.gtag('event', 'conversion', { send_to: 'AW-773394815/MStGCOjq_JUBEP-i5PAC' });
        window.gtag('event', 'conversion', { send_to: 'AW-773220615/QIv7CLK99ZUBEIfS2fAC' });
        window.gtag('event', 'conversion', { send_to: 'AW-773582775/FP93CPzR9ZUBELff7_AC' });
        window.gtag('event', 'conversion', { send_to: 'AW-775559410/6Cb_CK2q_ZUBEPKx6PEC' });
    }

    trackEvent(type, value) {
        const options = {
            hitType: 'event',
            eventCategory: 'Button',
            eventAction: 'click',
            eventLabel: type,
        };

        switch (type) {
            case 'treatment':
                options.dimension1 = value;
                options.eventLabel = 'Behandling';
                break;

            case 'clinic':
                options.dimension2 = value;
                options.eventLabel = 'Klinik';
                break;

            case 'list':
                options.dimension3 = value;
                options.eventLabel = 'Listning';
                break;

            case 'booking-done':
                options.dimension4 = 'Bokad - Återkommande patient';
                options.dimension8 = 'Ordinarie';
                options.dimension9 = 'Återkommande';
                options.eventLabel = 'Bokning';
                break;

            case 'booking-done-new':
                options.dimension4 = 'Bokad - Ny patient';
                options.dimension8 = 'Ordinarie';
                options.dimension9 = 'Ny';
                options.eventLabel = 'Bokning';
                break;

            case 'booking-done-lastminute':
                options.dimension4 = 'Bokad - Återkommande patient - Sista minuten';
                options.dimension8 = 'Sista minuten';
                options.dimension9 = 'Återkommande';
                options.eventLabel = 'Bokning';
                break;

            case 'booking-done-new-lastminute':
                options.dimension4 = 'Bokad - Ny patient - Sista minuten';
                options.dimension8 = 'Sista minuten';
                options.dimension9 = 'Ny';
                options.eventLabel = 'Bokning';
                break;

            case 'booking-cancelled':
                options.dimension4 = 'Avbokad';
                options.eventLabel = 'Bokning';
                break;

            case 'booking-rescheduled':
                options.dimension4 = 'Ombokad';
                options.eventLabel = 'Bokning';
                break;

            case 'confirm-request':
                options.dimension5 = 'Skickad';
                options.eventLabel = 'Bekräftelse';
                break;

            case 'confirm-done':
                options.dimension5 = 'Bekräftad';
                options.eventLabel = 'Bekräftelse';
                break;

            case 'bankid-login-started':
                options.dimension6 = 'Startad';
                options.eventLabel = 'BankID';
                break;

            case 'bankid-login-done':
                options.dimension6 = 'Inloggad';
                options.eventLabel = 'BankID';
                break;

            case 'time':
                options.dimension7 = value;
                options.eventLabel = 'Tid';
                break;

            case 'health':
                options.dimension10 = 'Sparad';
                options.eventLabel = 'Hälsodeklaration';
                break;

            default:
                break;
        }

        window.ga('send', options);
    }

    handleError(source, response, element) {
        if (response && response.error) {
            if (!response.error.handled) {
                response.error.handled = true;

                // eslint-disable-next-line no-console
                console.log('*** ERROR ***');
                // eslint-disable-next-line no-console
                console.dir(source);
                // eslint-disable-next-line no-console
                console.dir(response);
                // eslint-disable-next-line no-console
                console.log('*** /ERROR ***');
            }

            if (element) {
                let message = '';

                if (response.validationErrors && response.validationErrors.length > 0) {
                    message = response.validationErrors.map((error) => error.message).join(', ');
                } else {
                    message = response.error.message;
                }

                element.html(message).show();
            }
        } else {
            // eslint-disable-next-line no-console
            console.log('*** UNKNOWN ERROR ***');
            // eslint-disable-next-line no-console
            console.dir(source);
            // eslint-disable-next-line no-console
            console.dir(response);
            // eslint-disable-next-line no-console
            console.log('*** /UNKNOWN ERROR ***');

            if (element) {
                element.show();
            }
        }
    }

    validateApi(api) {
        let urlValid = true;

        if (!api.url.domain) urlValid = false;

        if (urlValid) {
            api.url.domain += api.url.domain.endsWith('/') || api.url.path.startsWith('/') ? '' : '/';

            urlValid = tools.isValidURL(`${api.url.domain}${api.url.path}`);
        }

        if (!urlValid)
            this.handleError(null, {
                message: 'INVALID DOMAIN URL for API',
                url: `${api.url.domain}${api.url.path}`,
            });

        return urlValid;
    }

    isValidURL(str) {
        const res = str.match(
            // eslint-disable-next-line no-useless-escape
            /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        );

        return res != null;
    }

    isValidReferrer(str) {
        // eslint-disable-next-line no-useless-escape
        return str && str.match(/^[a-z0-9\-\/]+$/i);
    }

    reducer(...funcs) {
        return (x) => {
            return funcs.reduce((y, func) => {
                return func(y);
            }, x);
        };
    }
}

export const debounce = (() => {
    const timers = {};
    return (callback, timeout, uniqueId) => {
        if (!uniqueId) {
            uniqueId = 'hd-id';
        }
        if (timers[uniqueId]) {
            clearTimeout(timers[uniqueId]);
        }
        timers[uniqueId] = setTimeout(callback, timeout);
    };
})();

export let tools = new Tools();



// WEBPACK FOOTER //
// ./scripts/booking/helpers/tools.js